import { Link } from 'react-router-dom';

import { Button, theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import { Video } from 'Components/Video';

import { skincareMinisPromoVideo as content } from 'assets/content/checkout/orderConfirmation';

const PromoWrapper = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;
  margin: 0 calc(${theme.spacing['6x']} * -1);
  max-height: 500px;
  height: 100%;

  ${mediaMinWidth('md')} {
    aspect-ratio: auto;
    max-height: none;
    margin: 0;
  }
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

const VideoCheckoutSuccessPromo = ({
  cta,
}: {
  cta: {
    dataClick: string;
    dataFrom: string;
    to: string;
  };
}) => {
  const { video } = content;
  return (
    <PromoWrapper>
      <Video
        autoplay
        fitCover
        fullHeight
        fullWidth
        isPositionAbsolute
        loop
        muted
        posterImage={video.poster}
        posterImageAlt=""
        videoSource={video.videoSrc}
      />
      {cta && (
        <ButtonWrapper>
          <Button asChild size="full" variant="subscription">
            <Link data-click={cta.dataClick} data-from={cta.dataFrom} to={cta.to}>
              Try custom skincare for free
            </Link>
          </Button>
        </ButtonWrapper>
      )}
    </PromoWrapper>
  );
};

export default VideoCheckoutSuccessPromo;
